<script>
  // Numeric value with an optional unit. Right-aligned by convention (set the
  // column align:'right'). Column may set `unit` (e.g. 'pts').
  let { value, column = {} } = $props()
  const text = $derived(value == null || value === '' ? null : Number(value).toLocaleString())
</script>

{#if text}
  <span class="tabular-nums">{text}{#if column.unit}<span class="text-base-content/50 ml-1">{column.unit}</span>{/if}</span>
{:else}
  <span class="text-base-content/40">—</span>
{/if}
